import { isLoggedIn } from '../api/cloudApiGenerated';

import store from '../redux/store';
import { snackBar } from 'highed';
import {
  setSubteams,
  getProfileAction,
  getGroupsAction,
  getSubscriptionAction,
  setLocalTeamAction,
  logoutAction,
  reloadDivisionsAction
} from '../redux/actions/profile';
import config from '../config';
export const checkLoggedIn = isLoggedIn;

export const checkPlanPermission = (permission, profile) => {
  // I dont know why this is in like 3 different places. TODO: sort this out.
  return profile.billingPermissions && profile.billingPermissions[permission];
};

export const checkPermission = (permission, profile = store.getState().profile) => {
  return (
    profile.permissions &&
    (profile.permissions[permission] || (profile.user && profile.team && profile.user.id === profile.team.owner_user))
  );
};

export const setTeam = (team, profile) => {
  store.dispatch(setLocalTeamAction({ team, config, profile }));
};

export const setDivision = (division) => {
  localStorage.setItem('division', JSON.stringify(division));
  store.dispatch(
    setSubteams({
      division
    })
  );
  snackBar('Changed subteam');
};

export const loadGroups = (team) => {
  store.dispatch(getGroupsAction({ team }));
};

export const loadSubscription = (team) => {
  store.dispatch(getSubscriptionAction({ team, config }));
};

export const googleTagManager = {
  tag: (params) => {
    if (typeof window.dataLayer === 'undefined') {
      return; // GA Tags not inited, too late now.
    }
    window.dataLayer.push(params);
  },
  tagSub: (teamId, selectedPlan, extraPlanDetails, quantity = 1) => {
    let details = {
      event: 'Subscribe',
      ecommerce: {
        purchase: {
          actionField: {
            id: teamId,
            revenue: 0
          },
          products: []
        }
      }
    };
    let planDetails = {
      id: 1,
      name: 'Free Plan',
      price: 0,
      quantity: quantity
    };
    if (extraPlanDetails && extraPlanDetails === 8) {
      planDetails.id = 8;
      planDetails.name = 'Trial';
    }

    if (selectedPlan && selectedPlan.id !== 1) {
      planDetails.sku = selectedPlan.id;
      planDetails.name = selectedPlan.name;
      planDetails.price = selectedPlan.price > 0 ? selectedPlan.price / 100 : selectedPlan.price;
      if (selectedPlan.price !== 0) {
        details.ecommerce.purchase.actionField.revenue = selectedPlan.price / 100;
      }
    }

    if (googleTagManager.tag) {
      details.ecommerce.purchase.products = [planDetails];
      googleTagManager.tag(details);
      googleTagManager.tagWizardStep('Sign Up');
    }
  },
  tagWizardStep: (step) => {
    if (step) {
      googleTagManager.tag({
        event: 'Pageview',
        pagePath: '/' + step.toLowerCase().replace(/ /g, '-'),
        pageTitle: step
      });
    }
  }
};

export const reloadDivisions = (team, profile) => {
  store.dispatch(reloadDivisionsAction({ team, profile, checkPermission }));
};

export const logout = () => {
  store.dispatch(logoutAction());
  localStorage.removeItem('editorTeam');
  localStorage.removeItem('team');
};

export const onGoogleLoggedIn = (announcements, newUser, history) => {
  store.dispatch(
    getProfileAction({
      config,
      getLast: false,
      announcements,
      checkPermission,
      callback: null,
      noLoading: null,
      newUser,
      saveChartAfterLogin: true,
      history,
      googleTagManager
    })
  );
};

export const onLoggedIn = (getLast = false, announcements, callback, noLoading, newUser = false) => {
  store.dispatch(
    getProfileAction({
      config,
      getLast,
      announcements,
      checkPermission,
      callback,
      noLoading,
      newUser,
      googleTagManager
    })
  );
};
